import React from "react";
import {Color} from "util/Color";
import {Flex, Image, Link, Text} from "@chakra-ui/react";

interface Props {
    color: "primary" | "secondary";
    imageSrc: string;
    text: React.ReactNode;
    url?: string;
    onClick?: () => void;
}

export const LinkButton = React.memo<Props>(({imageSrc, color, text, url, onClick}) => {
    return (
        <Link
            _hover={{textDecoration: "none"}}
            href={url}
            onClick={
                typeof onClick === "function"
                    ? e => {
                          e.preventDefault();
                          onClick?.();
                      }
                    : undefined
            }
        >
            <Flex mx={3} my={2} w="100px" h="100px" pt={2} alignItems="center" borderRadius="full" borderStyle="dashed" borderWidth="1px" borderColor={Color.happyPiglets} flexDirection="column">
                <Image w="28px" h="28px" src={imageSrc} />
                <Text
                    as="div"
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    fontSize="11px"
                    lineHeight="1.1"
                    color={color === "primary" ? Color.camelia : Color.peanut}
                    whiteSpace="nowrap"
                >
                    {text}
                </Text>
            </Flex>
        </Link>
    );
});
